import Entity from '../entity'

export default class ClaimDeference extends Entity<number>{
    claim_id: number;
    deference_type_id: number;
    comment: string;
}


